import AdministrativeRepresentativeTableContainer from './AdministrativeRepresentativeTableContainer';

export default AdministrativeRepresentativeTableContainer;